/* eslint-disable max-lines */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import styled from '@emotion/styled';
import H5 from '@base/H5/H5';
import P2 from '@base/P2/P2';

import Thumbnail from '@base/Thumbnail/Thumbnail';
import Tags from '@base/Tags/Tags';
import Link from '@base/Link/Link';
import BatchCardNew from '@comp/BatchCard/BatchCardNew';
import textHelper from '@utils/textHelper';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import pushRoute from '@utils/pushRoute';
import dateHelper from '@utils/dates';
import { segment } from '@actions/analytics';
import getTopicGroupAssetObj from '@cont/Syllabus/constants/getTopicGroupAssetObj';
import useWindowSize from '@hooks/useWindowSize';

import { Spacings, Fonts, mediaQuery } from '@styles/index';
import {
  isUpcoming as isUpcomingCourse,
  isOngoing as isOngoingCourse,
  isCompleted as isCompletedCourse
} from '@models/Course';
import SvgThumbail from '@comp/PlusCourseCard/placeholderCourseThumbail/SvgThumbnail';
import CoursePlaceholder from '@comp/PlusCourseCard/placeholderCourseThumbail/CoursePlaceholder';
import { GOAL_PAGE, SEE_ALL_CLICKED } from '@constants/segment';
import useGoalEventProps from '@hooks/useGoalEventProps';
import segmentStorage from '@events/segmentStorage';
import CardCarousel from './CardCarousel';

const SecWrapper = styled.section`
  position: relative;
  margin: auto;
  margin-top: 120px;
  width: 1376px;
  overflow: hidden;
  @media (max-width: 70.95em) {
    width: 728px;
    margin-top: 32px;
  }
  @media (max-width: 47.95em) {
    margin-top: 56px;
    width: 100%;
  }
`;

const PlaceholderThumbnail = styled(CoursePlaceholder)`
  height: 100%;
  width: 100%;
  background-color: var(--color-divider);
  object-fit: cover;
  ${mediaQuery.uptoMobile} {
    transform: scale(1);
  }
`;

const CardContainer = styled.div`
  width: 480px;
  height: 228px;
  margin-right: 24px;
  @media (max-width: 70.95em) {
    width: 272px;
    height: 314px;
    position: relative;
    margin-top: 32px;
  }
  @media (max-width: 47.95em) {
    margin-top: 0;
    margin-right: 16px;
    & > div:first-child {
      margin-left: ${({ $isBatch }) => ($isBatch ? '4px' : '0px')};
    }
  }
`;

const BatchCourse = styled(BatchCardNew)`
  width: 340px;
  /* height: 436px; */
  margin-right: ${Spacings.SPACING_5B};
  margin-bottom: ${Spacings.SPACING_8B};
  .batch-thumbnail {
    width: 100%;
    height: 190px;
  }
  ${mediaQuery.uptoMobile} {
    width: 272px;
    /* height: 388px; */
    .batch-thumbnail {
      width: 100%;
      height: 150px;
    }
  }
`;

const CardWrapper = styled.div`
  width: 440px;
  height: 188px;
  padding: 24px;
  background: var(--color-i-white);
  box-shadow: ${boxShadowGenerator()};
  border-radius: 8px;
  margin-left: 40px;
  position: relative;
  padding-left: 224px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 70.95em) {
    width: 272px;
    height: inherit;
    margin-left: 0;
    padding: 0;
    box-shadow: ${boxShadowGenerator()};
  }
  @media (max-width: 47.95em) {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }
`;

const LiveTag = styled(Tags)`
  position: absolute;
  @media (min-width: 70.95em) {
    left: -${Spacings.SPACING_6B};
    bottom: ${Spacings.SPACING_10B};
  }
  @media (max-width: 70.95em) {
    top: 108px;
    left: 16px;
  }
`;

const CardThumbnail = styled(Thumbnail)`
  &.thumbnail {
    width: 250px;
    height: 140px;
    box-shadow: ${boxShadowGenerator()};
    border-radius: 8px;
    position: absolute;
    left: -40px;
    @media (max-width: 70.95em) {
      position: relative;
      width: 100%;
      left: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`;

const CardTop = styled.div`
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  overflow: hidden;
  @media (max-width: 70.95em) {
    padding: 16px 16px 4px;
  }
`;

const BatchTagWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  left: -44px;
  top: 30px;
  height: 25px;
  @media (max-width: 70.95em) {
    top: 16px;
    left: -4px;
  }
`;

const HalfTriangle = styled.div`
  width: 0;
  height: 0;
  left: 10px;
  bottom: 38px;
  border-left: 6px solid transparent;
  border-bottom: 3px solid var(--color-base-fill);
`;

const BatchTag = styled.div`
  display: flex;
  align-items: center;
  height: 22px;
  background-color: var(--color-base-fill);
  border-radius: 4px;
  border-top-left-radius: 0px;
  padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_3B} ${Spacings.SPACING_0B}
    ${Spacings.SPACING_4B};
`;

const BatchTextTag = styled.span`
  font-size: ${Fonts.EXTRA_SMALL};
  color: var(--color-i-white);
  font-weight: bold;
  line-height: 100%;
`;

const TopicGroup = styled(Tags)`
  margin-left: ${Spacings.SPACING_2B};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${({ $color }) => $color};
`;

const LesssonsCount = styled(P2)`
  margin-top: ${Spacings.SPACING_1B};
  color: var(--color-text-secondary);
  @media (max-width: 70.95em) {
    padding: 0 16px;
  }
`;

const AuthorName = styled(P2)`
  display: flex;
  flex: 1;
  align-items: flex-end;
  @media (max-width: 70.95em) {
    padding: 0 16px;
    align-items: center;
  }
`;

const Title = styled(H5)`
  @media (max-width: 70.95em) {
    padding: 0 16px;
  }
`;

const SvgCourseThumbnail = styled(SvgThumbail)`
  width: 250px;
  height: 140px;
  box-shadow: ${boxShadowGenerator()};
  border-radius: 8px;
  position: absolute;
  left: -40px;
  @media (max-width: 70.95em) {
    position: relative;
    width: 100%;
    left: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

const DefaultThumbnail = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: ${Spacings.SPACING_2B};
`;

const Card = ({ course, goalUID, goalSlug, isBatch }) => {
  const {
    uid,
    name,
    slug,
    authors,
    isLive,
    languages,
    topicGroups,
    startsAt,
    endsAt
  } = course;
  const language =
    course.languageDisplay || course?.multipleLanguageDisplay?.[0];
  const nextTrack =
    course.nextTrack ||
    course.nextSession ||
    course.nextClass ||
    course.nextItem;
  const isUpcoming = isUpcomingCourse(course.startsAt);
  const isOngoing = isOngoingCourse(course.startsAt, course.endsAt);
  const isCompleted = course.isCompleted || isCompletedCourse(course.endsAt);
  const [author] = authors || (course.author ? [course.author] : []);
  const [topicGroup] = topicGroups || [];
  const asLink = `/${isBatch ? 'batch' : 'course'}/${
    slug || textHelper.getStringWordsJoinedWith(name)
  }/${uid}`;
  const redirectTopic = () => {
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/topic/[topicUid]',
      `/goal/${goalSlug}/${goalUID}/topic/${topicGroup?.uid}`
    );
  };

  const getCourseInfo = () => {
    const liveLessonRank = nextTrack?.rank;
    const liveAtString =
      nextTrack?.liveAtString || nextTrack?.properties?.liveAt;
    const liveLessonStartTime = new Date(liveAtString);
    if (
      isLive &&
      nextTrack &&
      liveLessonStartTime.toString() !== 'Invalid Date'
    ) {
      return `Lesson ${liveLessonRank} • Started at ${dateHelper.getTime(
        liveAtString
      )}`;
    }
    if (
      isOngoing &&
      nextTrack &&
      liveLessonStartTime.toString() !== 'Invalid Date'
    ) {
      const isToday = dateHelper.isSameDay(liveLessonStartTime, new Date());
      if (isToday)
        return `Lesson ${liveLessonRank} • Today, ${dateHelper.getTime(
          liveAtString
        )}`;
      return `Lesson ${liveLessonRank} • ${dateHelper.getFullDate(
        liveAtString
      )} ${dateHelper.getTime(liveAtString)}`;
    }
    if (isUpcoming) {
      const { itemCount: totalLessons } = course;
      return `Starts on ${dateHelper.getFullDate(
        startsAt
      )} • ${totalLessons} lessons`;
    }
    if (isCompleted) {
      const { itemCount: totalLessons } = course;
      return `Ended on ${dateHelper.getFullDate(
        endsAt
      )} • ${totalLessons} lessons`;
    }
  };

  const getBatchInfo = () => {
    if (!startsAt) return null;
    const startsAtDate = new Date(startsAt);
    const endsAtDate = endsAt ? new Date(endsAt) : null;
    const startsOn = dateHelper.getDateShort(startsAtDate);
    const currentDate = new Date();
    let dateString = '';
    if (currentDate.getTime() < startsAtDate.getTime()) {
      dateString = `Starts on ${startsOn}`;
    } else if (currentDate.getTime() > startsAtDate.getTime() && !endsAtDate) {
      dateString = `Started on ${startsOn}`;
    } else if (
      currentDate.getTime() > startsAtDate.getTime() &&
      currentDate.getTime() < endsAtDate.getTime()
    ) {
      dateString = `Started on ${startsOn}`;
    } else {
      dateString = `Ended on ${startsOn}`;
    }
    return dateString;
  };
  const handleAnalytics = () => {};

  const { color } = getTopicGroupAssetObj(topicGroup.title);
  const courseThumbnail =
    course.coverPhotoV1 || course.coverPhoto || course.thumbnail;

  return (
    <Link
      href={`/${isBatch ? 'batch' : 'course'}/[slug]/[courseUID]`}
      as={asLink}
      onClick={handleAnalytics}
    >
      <CardContainer $isBatch={isBatch}>
        <CardWrapper>
          {courseThumbnail ? (
            <CardThumbnail
              imgUrl={courseThumbnail}
              orientation="vertical"
              className="thumbnail"
            />
          ) : (
            <SvgCourseThumbnail as={DefaultThumbnail}>
              <PlaceholderThumbnail color={color} />
            </SvgCourseThumbnail>
          )}
          {isBatch && (
            <BatchTagWrapper>
              <HalfTriangle />
              <BatchTag>
                <BatchTextTag>BATCH</BatchTextTag>
              </BatchTag>
            </BatchTagWrapper>
          )}
          {isLive ? <LiveTag type="live">LIVE</LiveTag> : null}
          <CardTop>
            {isBatch ? (
              languages.map((lang) => (
                <Tags key={lang.code} type="hollow">
                  {lang.label}
                </Tags>
              ))
            ) : (
              <Tags type="hollow">{language}</Tags>
            )}
            {topicGroup && (
              <TopicGroup
                type="transparent"
                lineClamp={1}
                onClick={redirectTopic}
                $color={color}
              >
                {topicGroup.title}
              </TopicGroup>
            )}
          </CardTop>

          <Title lineClamp={2}>{name}</Title>
          <LesssonsCount>
            {isBatch ? getBatchInfo() : getCourseInfo()}
          </LesssonsCount>
          <AuthorName>
            {isBatch && author
              ? `${author?.firstName} ${author?.lastName} ${
                  authors.length > 1 ? `and ${authors.length - 1} more` : ''
                }`
              : `${author?.firstName} ${author?.lastName}`}
          </AuthorName>
        </CardWrapper>
      </CardContainer>
    </Link>
  );
};

const UpcomingSection = ({
  block,
  goalUID,
  goalSlug,
  href,
  as,
  type,
  goalDetails
}) => {
  const { isTablet, isMobile } = useWindowSize();
  const { name, uid } = goalDetails ?? {};
  const { data } = block;
  const label = block?.extraBlockInfo?.header || 'Courses starting soon';
  const subLabel =
    block?.extraBlockInfo?.description ||
    `Enroll in upcoming courses that best suit your schedule and ${name} exam syllabus`;
  const goalEvent = useGoalEventProps({ goalUID: uid });

  const seeAllClickEvent = () => {
    segment.track(SEE_ALL_CLICKED, {
      ...goalEvent,
      last_primary_source: GOAL_PAGE,
      last_primary_source_section: label
    });
  };

  const getCarouselSteps = () => {
    if (!(isTablet || isMobile) && data.length >= 3) return 3;
    return 2;
  };

  const onClick = (index) => {
    segmentStorage.setItem('lpss', `Non Hero Batch Section ${index}`);
  };

  return (
    <SecWrapper>
      <CardCarousel
        label={label}
        subLabel={subLabel}
        step={getCarouselSteps()}
        href={href}
        as={as}
        dataAnalytics={type}
        type={type}
        handleSeeAll={seeAllClickEvent}
      >
        {(type.includes('courses') ||
          type.includes('upcoming') ||
          type.includes('recently_started')) &&
          data?.map((course, index) => (
            <Card
              key={course.uid}
              course={course}
              goalUID={goalUID}
              goalSlug={goalSlug}
              href={href}
              as={as}
              dataAnalytics="course"
              label={label}
              index={index}
            />
          ))}
        {type.includes('batches') &&
          data?.map((batch, index) => (
            <BatchCourse
              label={label}
              index={index}
              key={batch.uid}
              batch={batch}
              isFeedCard
              lastPrimarySource="goal page"
              dataAnalytics="batch"
              hideEnroll
              onClick={() => onClick(index)}
            />
          ))}
      </CardCarousel>
    </SecWrapper>
  );
};

export default UpcomingSection;
